/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_No_Spaces_Search_HintInputs */



/**
* | output |
* | --- |
* | "Try adjusting your search terms" |
*
* @param {Datasets_No_Spaces_Search_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_no_spaces_search_hint = /** @type {((inputs?: Datasets_No_Spaces_Search_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_No_Spaces_Search_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passen Sie Ihre Suchbegriffe an")
	return /** @type {LocalizedString} */ ("Try adjusting your search terms")
});